<template>
	<div class="admin">
		<div class="container">
			<section>
				<n-space>
					<n-button type="success"
						@click="modals.createUser = true">Создать пользователя
					</n-button>
					<n-button type="error"
						@click="modals.deleteUser = true">Удалить пользователя
					</n-button>
					<n-button type="error"
						@click="modals.logs = true">Системные ошибки
					</n-button>
					<n-button type="error"
						@click="loadFromServer">Загрузить изменения с сервера
					</n-button>
				</n-space>
			</section>


			<n-modal v-model:show="modals.createUser">
				<CreateUserModal @modalclose="modals.createUser = false"/>
			</n-modal>
			<n-modal v-model:show="modals.deleteUser">
				<DeleteUserModal @modalclose="modals.deleteUser = false"/>
			</n-modal>
			<n-modal v-model:show="modals.logs">
				<LogsModal @modalclose="modals.logs = false"/>
			</n-modal>
		</div>
	</div>
</template>

<script setup>
import CreateUserModal from "@/app/components/admin/CreateUserComponent.vue"
import DeleteUserModal from "@/app/components/admin/DeleteUserComponent.vue"
import LogsModal from "@/app/components/admin/LogsComponent.vue"
import { useMessage } from "naive-ui"
import { useStore } from "vuex"
import { onMounted, reactive } from "vue"

const message = useMessage()
const store = useStore()

const loadFromServer = async () => {
	const response = await fetch(`${store.state.backend}/users/uploadfromserver`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ "token": store.state.admin.token, })
	})
	if (response.ok) {
		message.success("Игровые данные успешно загружены")
	} else {
		message.error("Не удалось загрузить игровые данные")
	}
}

const modals = reactive({
	createUser: false,
	deleteUser: false,
	logs: false
})
onMounted(() => {
	document.title = "WIKI BLACK RUSSIA: Панель администратора"
})
</script>

<style scoped lang="scss">
.admin {
  margin: 20px 0;
  width: 100%;
  height: 100%;

  section {
    background: #0f0f0f;
    border-radius: 5px;
    padding: 10px 20px;
    box-sizing: border-box;
    width: 100%;
  }
}

</style>